export default {
  ENV: 'staging',
  BASE_URL: 'https://api-staging-internal.mozio.com',
  BASE_URL_V2: 'https://api-staging-internal.mozio.com/v2',
  TRACKING_SERVICE_BASE_URL_V1: 'https://tracking-staging.mozio.com/v1',
}
